import { getAxiosInstanceApi } from "./api";
import { cachiosInstance } from "./cacheApi";

/**
 * ----------------------------
 *  Ghollak routes
 * ----------------------------
 */

export const getGhollaks = (query, force = false, callback) => {
    cachiosInstance.get(`/ghollak?${query}`, { force })
        .then(response => {
            const data = response.data;
            callback(true, data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
export const getGhollakMinBalance = (query, force = false, callback) => {
    cachiosInstance.get(`/ghollak-min-balance?${query}`, { force })
        .then(response => {
            const data = response.data;
            callback(true, data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
export const getSingleGhollak = (ghollakId, callback) => {
    cachiosInstance.get(`/ghollak/${ghollakId}?with_transaction=1`)
        .then(response => {
            const data = response.data;
            callback(true, data.data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
export const getGhollakTransactions = (query, callback) => {
    cachiosInstance.get(`/ghollak-transactions?${query}`)
        .then(response => {
            const data = response.data;
            callback(true, data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
export const getGhollakProfitCalculations = (query, force = false, callback) => {
    cachiosInstance.get(`/ghollak-profit-calculations?${query}`, { force })
        .then(response => {
            const data = response.data;
            callback(true, data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
export const getGhollakTransactionsExport = (query, callback) => {
    getAxiosInstanceApi().get(`/ghollak-transactions/export?${query}`)
        .then(response => {
            const data = response.data;
            callback(true, data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
export const getGhollakProfitCalculationsExport = (query, callback) => {
    getAxiosInstanceApi().get(`/ghollak-profit-calculations/export?${query}`)
        .then(response => {
            const data = response.data;
            callback(true, data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
export const updateGhollak = (ghollakId, query, callback) => {
    getAxiosInstanceApi().put(`/ghollak/${ghollakId}?${query}`)
        .then(response => {
            const data = response.data;
            callback(true, data.data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
export const addGhollakProfitProcess = (data, callback) => {
    getAxiosInstanceApi().post(`/ghollak-profit-calculations/process`, data)
        .then(response => {
            const data = response.data;
            callback(true, data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
